import React from 'react';

import PropTypes from 'prop-types';

import { formatDuration } from '@src/utils/dateTimeHelpers';

const Duration = (props) => {
    const { duration } = props;

    return (
        <h4>Estimated duration: {formatDuration(duration)}</h4>
    );
};

Duration.propTypes = {
    duration: PropTypes.number.isRequired,
};

export default Duration;
